import React from 'react';

import {
  TRADE_DIRECTION_BUY, TRADE_DIRECTION_SELL,
} from 'src/util/constants';
import { unitOfMeasure } from 'src/util/i18n/energyPrice';

/**
 * Returns the appropriate price label based on trade direction.
 * @param {import('react-intl').IntlShape} intl - The intl object for internationalization
 * @param {TRADE_DIRECTION_BUY | TRADE_DIRECTION_SELL | string} tradeDirection -
 * The trade direction (buy/sell)
 * @returns {string} Localized price label for the given direction or empty string for
 * invalid inputs
 */
export const getPriceLabel = (intl, tradeDirection) => {
  if (!intl) return '';

  switch (tradeDirection) {
    case TRADE_DIRECTION_BUY:
      return intl.formatMessage({
        id: 'trade_rule.trade_rule_set_community.i18n.helpers.maximum_buy_price.label',
        defaultMessage: 'Maximum buy price',
      });
    case TRADE_DIRECTION_SELL:
      return intl.formatMessage({
        id: 'trade_rule.trade_rule_set_community.i18n.helpers.minimum_sell_price.label',
        defaultMessage: 'Minimum sell price',
      });
    default:
      return '';
  }
};

/**
 * Returns the appropriate price help text based on trade direction.
 * @param {import('react-intl').IntlShape} intl - The request UI formatter.
 * @param {import('react-intl').IntlShape} intlCurrency - Partner currency formatter.
 * @param {string} tradeDirection - The trade direction (buy/sell)
 * @returns {React.ReactNode[] | string} Localized price help text for the given direction
 */
export const getPriceHelpText = (intl, intlCurrency, tradeDirection) => {
  if (!intl || !intlCurrency) return '';

  const energyPriceUnit = unitOfMeasure(intlCurrency);

  switch (tradeDirection) {
    case TRADE_DIRECTION_BUY:
      return intl.formatMessage({
        id: 'trade_rule.trade_rule_set_community.i18n.helpers.maximum_buy_price.hint',
        defaultMessage: 'What is the maximum price, in {energyPriceUnit}, that you will buy your energy from the community?',
      }, { energyPriceUnit });
    case TRADE_DIRECTION_SELL:
      return intl.formatMessage({
        id: 'trade_rule.trade_rule_set_community.i18n.helpers.minimum_sell_price.hint',
        defaultMessage: 'What is the minimum price, in {energyPriceUnit}, that you will sell your energy to the community?',
      }, { energyPriceUnit });
    default:
      return '';
  }
};
